import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { useContext, useMemo } from 'react';
import { getHeatingCircuitColor } from '../utils';
export const useHeatingCircuitControlValues = (default_min_temperature, default_nax_temperature) => {
    const { temp_step } = useContext(DeviceConfig);
    const temperature_decimal_places = useMemo(
    // https://git.microline.ru/zont/server/-/issues/1722
    // () => (temp_step == 1 ? 0 : 1),
    () => 1, [temp_step]);
    const { min_temperature, max_temperature } = useMemo(() => {
        const min_temperature = Number(default_min_temperature.toFixed(temperature_decimal_places));
        const max_temperature = Number(default_nax_temperature.toFixed(temperature_decimal_places));
        return { max_temperature, min_temperature };
    }, [default_nax_temperature, default_min_temperature]);
    return {
        temperature_decimal_places,
        min_temperature,
        max_temperature,
    };
};
export const useHeatingCircuitMode = (mode_id, heating_modes, summer_mode) => {
    const heating_mode = useMemo(() => heating_modes?.find(({ id }) => mode_id === id), [heating_modes, mode_id]);
    const heating_mode_color = useMemo(() => getHeatingCircuitColor(heating_modes, mode_id, summer_mode), [heating_modes, mode_id, summer_mode]);
    return { heating_mode, heating_mode_color };
};
